var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":40}},[_c('el-col',{attrs:{"md":16}},[_c('deal-payment')],1),_c('el-col',{attrs:{"md":8}},[_c('deal-order')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }